var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff"},[_c('span',{staticClass:"title"},[_vm._v("Show diff: ")]),_c('CustomSwitch',{attrs:{"value":_vm.value,"activeText":"#","inactiveText":"%"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }